import type { SearchResultRow } from '../../knowledgecenter/framework';

type Props = { results?: SearchResultRow[] };

export function SearchEnginePanel({ results = [] }: Props) {
  return (
    <div className="space-y-2">
      {results.map((r) => (
        <div key={r.query} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              <p className="text-xs font-medium text-brand-600">{r.mode}</p>
              <p className="mt-0.5 text-sm">&quot;{r.query}&quot;</p>
            </div>
            <p className="shrink-0 text-sm font-semibold text-slate-900 dark:text-slate-100">{r.results} hits</p>
          </div>
          <p className="mt-2 text-xs text-success-600">Top: {r.topHit}</p>
        </div>
      ))}
    </div>
  );
}
